function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "vmjya"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.772 29.52c-6.639-6.638-6.639-17.402 0-24.04l.707-.708c6.64-6.639 17.403-6.639 24.042 0l.707.707c6.639 6.64 6.639 17.403 0 24.042l-.707.707c-6.64 6.639-17.403 6.639-24.042 0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e5e5e5",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M5.772 29.52c-6.639-6.638-6.639-17.402 0-24.04l.707-.708c6.64-6.639 17.403-6.639 24.042 0l.707.707c6.639 6.64 6.639 17.403 0 24.042l-.707.707c-6.64 6.639-17.403 6.639-24.042 0z",
  clipPath: "url(\"#vmjya\")"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.181 21.395l-4.114-4.114 4.114-4.114a.83.83 0 0 0 0-1.175l-.392-.392a.83.83 0 0 0-1.175 0L18.5 15.714 14.387 11.6a.831.831 0 0 0-1.176 0l-.392.391a.83.83 0 0 0 0 1.176l4.114 4.114-4.114 4.114a.831.831 0 0 0 0 1.175l.392.392a.831.831 0 0 0 1.175 0l4.114-4.114 4.114 4.114a.83.83 0 0 0 1.176 0l.391-.392a.831.831 0 0 0 0-1.175z"
}))))));

var SvgOutlined = function SvgOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/_Outlined.516dc04b.svg";
export { ForwardRef as ReactComponent };